import type {
  WorkflowReferenceAction,
  WorkflowReferenceKind,
} from "@/types/workflow-reference.types";
import type { StepType } from "@/types/workflow.types";

export interface ReferenceFieldConfig {
  kind: WorkflowReferenceKind;
  action: WorkflowReferenceAction;
  mode: "single" | "multi";
  fieldKey: string;
}

const FIELD_MAP: Record<string, Omit<ReferenceFieldConfig, "action" | "fieldKey"> & { action?: WorkflowReferenceAction }> = {
  knowledge_ids: { kind: "knowledge", mode: "multi", action: "read" },
  target_knowledge_id: { kind: "knowledge", mode: "single", action: "write" },
  folder_ids: { kind: "folder", mode: "multi", action: "read" },
  target_folder_id: { kind: "folder", mode: "single", action: "write" },
  tag_ids: { kind: "tag", mode: "multi", action: "read" },
  category_id: { kind: "category", mode: "single", action: "read" },
  category_ids: { kind: "category", mode: "multi", action: "read" },
  target_category_id: { kind: "category", mode: "single", action: "write" },
  media_asset_ids: { kind: "media_asset", mode: "multi", action: "read" },
  workflow_id: { kind: "workflow", mode: "single", action: "run" },
  workflowid: { kind: "workflow", mode: "single", action: "run" },
  connector_id: { kind: "connector", mode: "single" },
  connectorid: { kind: "connector", mode: "single" },
  tool_id: { kind: "mcp_tool", mode: "single", action: "use" },
  tools: { kind: "mcp_tool", mode: "multi", action: "use" },
  entity_id: { kind: "kg_entity", mode: "single", action: "read" },
  approvers: { kind: "principal_user", mode: "multi", action: "read" },
  model_id: { kind: "aic_model", mode: "single", action: "use" },
};

export function getReferenceFieldConfig(
  key: string,
  nodeType: StepType,
): ReferenceFieldConfig | null {
  const normalized = normalizeConfigKey(key);
  if (normalized === "authresourceid" || normalized.includes("secret")) return null;
  const config = FIELD_MAP[normalized];
  if (!config) return null;
  return {
    ...config,
    action: config.action ?? connectorActionForNode(nodeType),
    fieldKey: key,
  };
}

function connectorActionForNode(nodeType: StepType): WorkflowReferenceAction {
  if (nodeType === "load" || nodeType === "api_load") return "write";
  return "read";
}

function normalizeConfigKey(key: string) {
  return key.replace(/([a-z0-9])([A-Z])/g, "$1_$2").toLowerCase();
}
